import { render, staticRenderFns } from "./u-tabs-filled.vue?vue&type=template&id=a0a6433c&scoped=true&"
import script from "./u-tabs-filled.vue?vue&type=script&lang=js&"
export * from "./u-tabs-filled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a6433c",
  null
  
)

export default component.exports